import { IGameAttendances } from "./IGameAttendances";

export enum GameStatues {
  SCHEDULED = "SCHEDULED",
  CONFIRMED = "CONFIRMED",
  CANCELED = "CANCELED",
  FINISHED = "FINISHED",
  FINALIZED = "FINALIZED",
}

export interface IGame {
  created_at: string;
  datetime: string | null;
  group_id: number | null;
  host_score: number | null;
  id: number;
  location: string | null;
  notes: string | null;
  status: GameStatues;
  visitor_score: number | null;
  group: {
    id: number;
    name: string;
    created_at: string;
  };
  attendees: IGameAttendances[];
}
